export default __webpack_public_path__ + "asset/img/shop-logo/6~1e7abdf0.png";